// src/utils/roles.ts
export const ROLES = {
  OWNER: 'owner',
  ADMIN: 'admin',
  MANAGER: 'manager',
  STAFF: 'staff',
  RECEPTIONIST: 'receptionist',
  CUSTOMER: 'customer'
};

export const PERMISSIONS = {
  VIEW_DASHBOARD: 'view_dashboard',
  MANAGE_BOOKINGS: 'manage_bookings',
  MANAGE_STAFF: 'manage_staff',
  MANAGE_EMPLOYEES: 'manage_staff',
  MANAGE_SERVICES: 'manage_services',
  MANAGE_CUSTOMERS: 'manage_customers',
  VIEW_REPORTS: 'view_reports'
};